<template>
  <v-container class="container-form">
    <BackArrow class="mt-8" />
    <v-subheader class="title mt-n4 mb-4 pa-0 black--text">
      {{ id ? "Editar Escala de Viagem" : "Cadastrar Escala de Viagem" }}
    </v-subheader>

    <v-form
      ref="form"
      v-model="valid"
      lazy-validation
      autocomplete="off"
      @submit.prevent
    >
      <v-card class="mb-15">
        <v-card-title class="primary white--text d-flex justify-space-between">
          <span>Escalas</span>
          <span>Campos Obrigatórios *</span>
        </v-card-title>

        <v-card-text class="pt-7 px-7">
          <v-row>
            <v-col cols="12" sm="3">
              <span class="primary--text">Data *</span>
              <v-menu
                ref="menu"
                v-model="menu"
                :close-on-content-click="false"
                transition="scale-transition"
                offset-y
                max-width="290px"
                min-width="auto"
              >
                <template v-slot:activator="{ on, attrs }">
                  <v-text-field
                    v-model="dateFormatted"
                    prepend-icon="mdi-calendar"
                    readonly
                    v-bind="attrs"
                    v-on="on"
                    placeholder="Informe a data"
                    @blur="date = parseDate(dateFormatted)"
                    class="pt-1"
                  ></v-text-field>
                </template>
                <v-date-picker
                  v-model="date"
                  @input="menu = false"
                ></v-date-picker>
              </v-menu>
            </v-col>
            <v-col cols="12" sm="9">
              <span class="primary--text">Viagem *</span>
              <v-autocomplete
                v-model="id_viagens"
                :rules="fieldRules"
                :items="viagens"
                item-text="descricao"
                item-value="id"
                required
                placeholder="Informe a Viagem"
                class="mt-1 custom-solo-selection"
                solo
              >
                <template slot="selection" slot-scope="{ item }"
                  >{{ item.horario }} - {{ item.descricao }}</template
                >
                <template slot="item" slot-scope="{ item }"
                  >{{ item.horario }} - {{ item.descricao }}</template
                >
              </v-autocomplete>
            </v-col>
            <v-col cols="12" sm="6">
              <span class="primary--text">Ônibus *</span>
              <v-autocomplete
                v-model="id_bus"
                :rules="fieldRules"
                :items="bus"
                item-text="descricao"
                item-value="id"
                required
                placeholder="Informe o Ônibus"
                class="mt-1 custom-solo-selection"
                solo
              ></v-autocomplete>
            </v-col>
            <v-col cols="12" sm="6">
              <span class="primary--text">Motorista *</span>
              <v-autocomplete
                v-model="id_motorista"
                :rules="fieldRules"
                :items="motoristas"
                item-text="nome"
                item-value="id"
                required
                placeholder="Informe o Motorista"
                class="mt-1 custom-solo-selection"
                solo
              ></v-autocomplete>
            </v-col>
            <v-col cols="12" sm="6">
              <span class="primary--text">Origem (Trecho Inicial) *</span>
              <v-autocomplete
                v-model="id_origem"
                :rules="fieldRules"
                :items="localidades"
                item-text="nome"
                item-value="id"
                required
                placeholder="Informe a Origem (Trecho Inicial)"
                class="mt-1 custom-solo-selection"
                solo
              ></v-autocomplete>
            </v-col>
            <v-col cols="12" sm="6">
              <span class="primary--text">Destino (Trecho Final) *</span>
              <v-autocomplete
                v-model="id_destino"
                :rules="fieldRules"
                :items="localidades"
                item-text="nome"
                item-value="id"
                required
                placeholder="Informe o Destino (Trecho Final)"
                class="mt-1 custom-solo-selection"
                solo
              ></v-autocomplete>
            </v-col>
            <v-col cols="12" sm="12">
              <span class="primary--text">Observações</span>
              <v-textarea
                v-model="obs"
                class="mt-n1"
              ></v-textarea>
            </v-col>
          </v-row>
        </v-card-text>
      </v-card>
      <v-footer color="primary" class="rounded-t footer-form" absolute>
        <div class="flex-grow-1"></div>
        <v-btn dark depressed text :disabled="!valid" @click="validate"
          >Confirmar</v-btn
        >
      </v-footer>
    </v-form>
    <v-snackbar
      v-model="message.snacshow"
      :color="message.type"
      :multi-line="message.mode === 'multi-line'"
      :timeout="message.timeout"
      :vertical="message.mode === 'vertical'"
      bottom
    >
      {{ message.text }}
      <v-btn dark text @click="message.snacshow = false">
        <v-icon small>mdi-close</v-icon>
      </v-btn>
    </v-snackbar>
  </v-container>
</template>

<script>
import BackArrow from "../../../components/BackArrow/index.vue";
export default {
  props: ["id"],
  data: vm => ({
    menu: false,
    message: {
      snacshow: false,
      text: "",
      type: "",
      mode: "",
      timeout: 2000,
    },

    motoristas: [],
    bus: [],
    viagens: [],
    localidades: [],

    valid: true,
    fieldRules: [(v) => !!v || "Este campo é requerido"],

    date: new Date().toISOString().substring(0, 10),
    dateFormatted: vm.formatDate(new Date().toISOString().substring(0, 10)),
    id_bus: "",
    id_viagens: "",
    id_origem: "",
    id_destino: "",
    id_motorista: "",
    obs: ""
  }),
  created() {
    this.loader("motoristas");
    this.loader("bus");
    this.loader("viagens");
    this.loader("localidades");

    if (this.id) {
      this.$store.dispatch("activeLoader", true);
      this.$http
        .get(`/escalas/${this.id}`)
        .then((r) => {
          this.date = r.data[0].data;
          this.dateFormatted = this.formatDate(r.data[0].data);
          this.id_bus = r.data[0].id_bus;
          this.id_viagens = r.data[0].id_viagens;
          this.id_origem = r.data[0].id_origem;
          this.id_destino = r.data[0].id_destino;
          this.id_motorista = r.data[0].id_motorista;
          this.obs = r.data[0].obs;
          this.$store.dispatch("activeLoader", false);
        })
        .catch((e) => {
          this.$store.dispatch("activeLoader", false);
          this.message.text = e;
          this.message.snacshow = true;
          this.message.type = "success";
        });
    }
  },
  watch: {
    date () {
      this.dateFormatted = this.formatDate(this.date)
    },
  },
  methods: {
    formatDate (date) {
      if (!date) return null

      const [year, month, day] = date.split('-')
      return `${day}/${month}/${year}`
    },
    parseDate (date) {
      if (!date) return null

      const [day, month, year] = date.split('/')
      return `${year}-${month.padStart(2, '0')}-${day.padStart(2, '0')}`
    },
    validate() {
      if (this.$refs.form.validate()) {
        this.salvar();
      } else {
        this.message.snacshow = true;
        this.message.type = "warning";
        this.message.text =
          "Atencão um ou mais campos precisam ser preenchidos!";
      }
    },
    loader(table) {
      this.$store.dispatch("activeLoader", true);
      this.$http
        .get(`/` + table)
        .then((r) => {
          table == "motoristas"
            ? (this.motoristas = r.data)
            : table == "bus"
            ? (this.bus = r.data)
            : table == "viagens"
            ? (this.viagens = r.data)
            : table == "localidades"
            ? (this.localidades = r.data)
            : [];
          this.$store.dispatch("activeLoader", false);
        })
        .catch((e) => {
          this.$store.dispatch("activeLoader", false);
          this.message.text = e;
          this.message.snacshow = true;
          this.message.type = "success";
        });
    },
    salvar() {
      this.$store.dispatch("activeLoader", true);
      if (this.id) {
        this.$http
          .post(`/escalas/update/${this.id}`, {
            data: this.date,
            id_bus: this.id_bus,
            id_viagens: this.id_viagens,
            id_origem: this.id_origem,
            id_destino: this.id_destino,
            id_motorista: this.id_motorista,
            obs: this.obs
          })
          .then((r) => {
            this.$store.dispatch("activeLoader", false);
            if (r.data.success) {
              this.message.text = r.data.success;
              this.message.snacshow = true;
              this.message.type = "success";
              setTimeout(() => {
                this.$router.push("/escalas");
              }, 500);
            }
          })
          .catch((e) => {
            this.$store.dispatch("activeLoader", false);
            this.message.text = e;
            this.message.snacshow = true;
            this.message.type = "success";
          });
      } else {
        this.$http
          .post("/escalas/create", {
            data: this.date,
            id_bus: this.id_bus,
            id_viagens: this.id_viagens,
            id_origem: this.id_origem,
            id_destino: this.id_destino,
            id_motorista: this.id_motorista,
            obs: this.obs
          })
          .then((r) => {
            this.$store.dispatch("activeLoader", false);
            if (r.data.success) {
              this.message.text = r.data.success;
              this.message.snacshow = true;
              this.message.type = "success";
              setTimeout(() => {
                this.$router.push("/escalas");
              }, 500);
            }
          })
          .catch((e) => {
            this.$store.dispatch("activeLoader", false);
            this.message.text = e;
            this.message.snacshow = true;
            this.message.type = "success";
          });
      }
    },
  },
  components: { BackArrow },
};
</script>

<style src="../style.vue"></style>
